import { useEffect, useState } from "react";
import nodeinstance from "../../../../nodeInstance";
import { useDispatch } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import EmployeeSalaryPackage from "./employeeSalaraypackage";
import EmployeeList from "./employeeList";
import SummaryList from "./summaryList";
import { useLocation } from "react-router-dom";
import Employeeseclist from "./Editemployeelist";
import { PDFDownloadLink } from "@react-pdf/renderer";
import SecDepositeonarrival from "../../DummyPdfs/Pdf2Components/secDepositeformOnArrival";

export default function VisacostOnarrivalMain({
  quotationType,
  propData,
  setOnArrivalInvoice,
}) {
  console.log(
    "Data to be capctured here sridharmmm.......",
    quotationType,
    propData
  );
  const dispatch = useDispatch();
  const [responseData, setResponseData] = useState();
  const token = localStorage.getItem("nodeToken");
  const response = async () => {
    try {
      const data = await nodeinstance.get(
        `/dashboard/visaSecurity/${propData?.id}/${quotationType}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (data.status === 200) {
        console.log("data to be seen here.....", data);
        setResponseData(data?.data?.data);
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };

  console.log("responseData......responseData", responseData);

  const location = useLocation();
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
    routeName: "",
  });
  useEffect(() => {
    if (location.pathname.split("/")[3] === "summary-OnArrival") {
      setAddOrEdit((p) => ({
        ...p,
        open: true,
        method: "add",
        routeName: "summaryTable",
      }));
    } else if (
      location.pathname.split("/")[3] === "summary-OnArrival-editEmployee"
    ) {
      setAddOrEdit((p) => ({
        ...p,
        open: true,
        method: "add",
        routeName: "summaryEditTable",
      }));
    }
  }, [location]);

  const [invoiceNumber, setInvoiceNumber] = useState();
  const [invoiceSummary, setInvoiceSummary] = useState();

  const InvoiceSummary = async () => {
    try {
      const response = await nodeinstance.get(
        `/dashboard/visaSecOnArrival/invoiceRaised/${propData?.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setInvoiceSummary(response?.data?.data);
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: "Failed to fetch invoice summary Data",
        })
      );
    }
  };
  const [summaryUpdate, setSummaryUpdate] = useState();
  const [render, setRender] = useState(false);
  useEffect(() => {
    InvoiceSummary();
  }, [render, summaryUpdate]);

  useEffect(() => {
    response();
    InvoiceSummary();
  }, [quotationType]);

  console.log("propData.........", propData);

  useEffect(() => {
    dispatch(
      setBreadCrumb([
        {
          label: "VISA COST AND SECURITY DEPOSIT",
          link: "/dashboard/visa-cost-&-sec-deposit",
        },
        {
          label: `${responseData && responseData[0]?.contract_number}`,
          link: "/dashboard/visa-cost-&-sec-deposit",
        },
      ])
    );
  }, [location, responseData]);

  console.log("responseData........", responseData);

  const [selectedInvoice, setSelectedInvoice] = useState([]);

  console.log("selectedInvoice..........", selectedInvoice);

  const downloadInvoice = async () => {
    try {
      const response = await nodeinstance.get(
        `/dashboard/visaSecOnArrival/downloadZip/${propData}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        // const blob = await response.blob();
        const contentType = response.headers["content-type"];
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "visa_cost_invoice_onArrival.zip");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log("error to be seen here....", error);
      dispatch(
        setAppError({
          msg: "Error while downloading Invoice",
        })
      );
    }
  };
  const [excelDownload, setExcelDownload] = useState(false);

  const downloadReport = async () => {
    try {
      console.log("..........propData......",propData)
      const response = await nodeinstance.get(
        `/dashboard/visaSecOnArrival/excelDownload`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Visa-cost-security-deposite--OnArrival-report`
        );
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setExcelDownload(false);
      }
    } catch (error) {
      console.log("error to be displayed here....", error);
      dispatch(
        setAppError({
          msg: "Error while generating report",
        })
      );
    }
  };
  const [costPlusInvoiceDownload, setCostPlusInvoiceDownload] = useState(false);
 

  const handleDownloadClick = () => {
    if (selectedInvoice?.length === 0) {
      dispatch(
        setAppError({
          msg: "Invoice not selected",
        })
      );
      return;
    }
    setCostPlusInvoiceDownload(true);
  };
  return (
    <>
      {responseData?.length <= 0 ? (
        <LoadingWithLable className="col-span-11" />
      ) : addOrEdit.routeName === "summaryEditTable" ? (
        <Employeeseclist invoiceNumber={invoiceNumber} contract_id={propData} quotationType = {quotationType} />
      ) : (
        <div className="pt-2 uppercase m-3">
          {/* <div className="flex flex-wrap  gap-2 w-full items-center "> */}
          <div className="flex flex-wrap gap-2 mb-1 items-center">
            <button
              className="p-2 bg-red text-white rounded-md"
              style={{ width: "200px" }}
              // onClick={handlecreateVRFroute}
            >
              ON ARRIVAL
            </button>
          </div>
          <div className="flex flex-wrap gap-2 mb-1 items-center">
            <p
              style={{ fontWeight: "bold", fontSize: "15px" }}
              className="ml-5"
            >
              cost sheet: {quotationType ? quotationType : ""}
            </p>
            <div className="ml-auto flex gap-2">
              <div className="peer">
                {/* <button className="flex justify-center items-center gap-2 ring-1 ring-slate-300 shadow-sm font-semibold text-black bg-slate-50 p-2 px-3 rounded-md w-full text-xs text-center  disabled:bg-slate-300 disabled:cursor-not-allowed hover:bg-blue hover:text-white disabled:hover:text-black">
                  <PDFDownloadLink
                    // document={<VrfPdfDownload data={listItem} />}
                    document={
                      <SecDepositeonarrival
                        header={"REQUEST FOR SECURITY DEPOSIT"}
                        data={selectedInvoice}
                        contractNumber={
                          responseData && responseData[0]?.contract_number
                        }
                        clientDetails={clientDetails}
                      />
                    }
                    fileName="SEC_DEPOSITE_COST.pdf"
                    onLoadSuccess={() => setCostPlusInvoiceDownload(false)} // Reset the state after download
                  >
                    {({ pdfLoading }) => (
                      <button
                        onClick={handleDownloadClick}
                        disabled={selectedInvoice?.length == 0}
                      >
                        DOWNLOAD SECURITY DEPOSIT FORM
                      </button>
                    )}
                  </PDFDownloadLink>
                </button> */}
              </div>
              {/* <div className="relative">
                <div className="peer">
                  <button className="flex items-center gap-2 bg-blue text-white p-2 px-3  rounded-md w-fit text-xs text-center ">
                    Download
                  </button>
                </div>
                <div
                  className={
                    "hidden absolute -top-[1.5rem] transform -translate-x-1/2 max-w-xs w-[14rem] h-auto bg-white shadow-xl rounded-lg p-2 ring-1 ring-slate-400  peer-hover:flex hover:flex flex-col gap-2"
                  }
                >
                  <button
                    className="flex justify-center items-center gap-2 ring-1 ring-slate-300 shadow-sm font-semibold text-black bg-slate-50 p-2 px-3 rounded-md w-full text-xs text-center  disabled:bg-slate-300 disabled:cursor-not-allowed hover:bg-blue hover:text-white disabled:hover:text-black"
                    onClick={() => {
                      downloadReport();
                    }}
                  >
                    DOWNLOAD REPORT
                  </button>
                
                </div>
              </div> */}
            </div>
          </div>
          <div>
            <EmployeeSalaryPackage
              propData={responseData}
              quotationType={quotationType}
              invoiceSummary={invoiceSummary}
              countdata={propData}
            />
          </div>
          <div>
            <EmployeeList
              quotationType={quotationType}
              quotationId={propData}
              invoiceSummary={invoiceSummary}
              render={render}
              setRender={setRender}
              contract_id={propData}
              setSummaryUpdate={setSummaryUpdate}
              summaryUpdate={summaryUpdate}
            />
          </div>
          <div className="mt-4">
            <SummaryList
              quotationType={quotationType}
              quotationId={propData}
              setInvoiceNumber={setInvoiceNumber}
              setOnArrivalInvoice={setOnArrivalInvoice}
              setSummaryUpdate={setSummaryUpdate}
              summaryUpdate={summaryUpdate}
              setSelectedInvoice={setSelectedInvoice}
              selectedInvoice={selectedInvoice}
            />
          </div>
        </div>
      )}
    </>
  );
}
